import Benefit from '../../models/Benefits/Benefit';
import { OrderedMap } from 'immutable';
import { Action } from 'redux';

import {
    GET_BENEFITS_REQUEST,
    GET_BENEFITS_RESPONSE,
    GET_BENEFITS_ERROR,
    SET_BENEFITS_PAGE
} from '../../actions/Benefits/benefits';

export interface BenefitsState {
    benefits: OrderedMap<number, Benefit>;
    page: number;
    loading: boolean;
    hasMore: boolean;
}

const initialState: BenefitsState = {
    benefits: OrderedMap<number, Benefit>(),
    page: 1,
    loading: false,
    hasMore: true
};

export const benefitsState = (state: BenefitsState = initialState, action: Action): BenefitsState => {
    switch (action.type) {
        case GET_BENEFITS_REQUEST: {
            return {
                ...state,
                loading: state.benefits.isEmpty() || state.page === 1
            };
        }
        case GET_BENEFITS_RESPONSE: {
            const page = (action as any).response.page.current_page;

            const newBenefits = (action as any).response.result
                .reduce((prev: any, cur: any) => prev.set(cur.id, cur), OrderedMap<number, Benefit>());

            const benefits = page === 1 ? newBenefits : state.benefits.concat(newBenefits);

            return {
                ...state,
                benefits,
                page,
                loading: false,
                hasMore: !!(action as any).response.page.next_page
            };
        }
        case GET_BENEFITS_ERROR: {
            console.error((action as any).error);
            return {
                ...state,
                loading: false
            };
        }
        case SET_BENEFITS_PAGE: {
            return {
                ...state,
                page: (action as any).page
            };
        }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/Benefits/benefits.ts